import { render } from "./AddAnnouncement.vue?vue&type=template&id=75983950&scoped=true"
import script from "./AddAnnouncement.vue?vue&type=script&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&lang=js"

import "./AddAnnouncement.vue?vue&type=style&index=0&id=75983950&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75983950"]])

export default __exports__